import { MLB_PLAY_PRO } from '@sorare/core/src/constants/__generated__/routes';

import { NoCardEntryDecline as USSportsNoCardEntryDecline } from '@sorare/us-sports/src/components/lobby/NoCardEntry/routes/decline';

const NoCardEntryDecline = () => (
  <USSportsNoCardEntryDecline lobbyRoute={MLB_PLAY_PRO} />
);

export default NoCardEntryDecline;
